module.exports = __webpack_public_path__ + "img/adoption-request.ddde6e0d.svg";